export default __webpack_public_path__ + "static/img4@2x-10fe629035ebb501ff73df9403cb3b57.png";